module.exports = __webpack_public_path__ + "img/1-03.d02097d7.png";